import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Toggle from './toggle'
import Input from '../input'
import Button from '../button/button'
import { COLORS } from '../../utils/colors'
import Modal from '../modal'
import DiscordImage from '../../../images/discord.png'

const ContentBox = styled.div`
  text-align: center;
  p {
    margin: 0;
    font-size: 1.1em;
  }
`
const DiscordImg = styled.img`
  width: 200px;
  margin-top: 32px;
  display: inline-block;
`

const Feedback = ({ history }) => {
  return (
    <Modal
      title='Feedback'
      onCloseLink='/'>
      <ContentBox>
        <p>
          We invite you to join our Discord community for faster support, the latest game updates, announcements, feedback opportunities, and friends to play with!
        </p>
        <a href="https://discord.gg/9KMMksmsY7" target="_blank" title="Join our Discord community">
          <DiscordImg src={DiscordImage} width={200} />
        </a>
        <p style={{ marginTop: 24 }}>
          You may also reach us via email at: <br /><br />
          <a href="mailto:feedback@wordgrid.io?subject=Feedback%20on%20WordGrid">
            feedback@wordgrid.io
          </a>
        </p>
      </ContentBox>
    </Modal>
  )
}

export default Feedback
